import { FC } from 'react';

import { Skeleton } from '@savgroup-front-common/core/atoms/Skeleton';
import { ProductsInfo } from '@/view/components/ProductsInfo';

import { OwnerProductSummaryDto } from '../../HomePage.types';

import { useGetProductsDetails } from './HomePageFileItem.hooks';
import { $LoadingWrapper } from './HomePageFileItem.styles';

export const HomePageFileItem: FC<{ product: OwnerProductSummaryDto }> = ({
  product,
}) => {
  const { productsDetails, histories, isLoading, handleShowProduct } =
    useGetProductsDetails({
      product,
    });

  if (isLoading) {
    return (
      <$LoadingWrapper>
        <Skeleton height="100%" width="100%" />
      </$LoadingWrapper>
    );
  }

  if (!product.fileId) {
    return null;
  }

  return (
    <ProductsInfo
      productsInfo={productsDetails}
      histories={histories}
      hasHistory
      onClick={() => handleShowProduct({ fileId: product.fileId })}
    />
  );
};
